import { PressureActionTypes } from '~/actions/pressure';

const initialState = {
  data: null,
  isLoading: true,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case PressureActionTypes.LOAD_PRESSURE:
      if (action.pressure_data && action.pressure_data.length) {
        return {
          ...state,
          isLoading: false,
          data: action.seepage,
        };
      }

      return {
        ...state,
        data: null,
        isLoading: false,
      };

    case PressureActionTypes.RESET_IS_LOADING:
      return {
        ...state,
        isLoading: true,
        data: null,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./resources/assets/js/reducers/seepage.js